import generalConstants from 'src/constants/general';

import { lang } from './lang';
import LANG_CONST from './lang/const';

export const normalizeChatTicketValue = (value) => {
  if (value === null || value === undefined || value === '') return null;

  const numericValue = Number(value);

  return Number.isNaN(numericValue) ? null : numericValue;
};

export const getDoctorChatTicketLabel = (
  chatTicket,
  currency = generalConstants.defaultCurrency
) => {
  if (!chatTicket) return null;

  const price = normalizeChatTicketValue(chatTicket.price);
  const duration = normalizeChatTicketValue(chatTicket.duration);
  const messagesCount = normalizeChatTicketValue(chatTicket.messagesCount);

  if ([price, duration, messagesCount].some((value) => value === null)) {
    return null;
  }

  return lang.t(LANG_CONST.text.doctor_session_chat, {
    price,
    currency,
    duration,
    messagesCount
  });
};